module.exports = __webpack_public_path__ + "static/media/grid.a31c1688.svg";